import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

const ExternalPurchaseForm = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  storeName,
  shippingAddress,
  stillNeeds,
}) => (
  <form className="external-purchase-form" onSubmit={handleSubmit}>
    <h3>Enter your email</h3>
    <div className="row">
      <div className="col-xs-12 col-sm-6">
        <Field
          name="giftGiverEmail"
          type="email"
          id="external-purchase-gift-giver-email"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.EMAIL]}
          placeholder="Your Email"
          required
        />
      </div>
      <div className="col-xs-12 col-sm-6">
        <Field
          name="confirmGiftGiverEmail"
          type="email"
          id="external-purchase-confirm-gift-giver-email"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.EMAIL]}
          placeholder="Confirm Email"
          required
        />
      </div>
    </div>

    <p className="text-muted small">
      Your email is used to help the couple with gift tracking and your personal information is
      secure. You can learn more about this in our{' '}
      <a href="/privacy" target="_blank" rel="noreferrer noopener">
        privacy policy
      </a>
    </p>

    {shippingAddress && (
      <div className="copy-address">
        <h4>Want to send this gift directly to the couple? Copy this address:</h4>
        <div>
          <div className="value-label">
            {shippingAddress.first_name} {shippingAddress.last_name}
            <br />
            {shippingAddress.street_address_1}
            <br />
            {shippingAddress.street_address_2 && (
              <span>
                {shippingAddress.street_address_2}
                <br />
              </span>
            )}
            {shippingAddress.city}, {shippingAddress.state_province_region}{' '}
            {shippingAddress.postal_code}
          </div>
        </div>
      </div>
    )}

    <h4>
      Come back to the couple&#39;s Zola registry to tell us if you bought this, so we can help keep
      track of all their gifts.
    </h4>

    <div className="still-needs">still needs: {stillNeeds}</div>

    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton
        pristine={pristine}
        submitting={submitting}
        valid={valid || true}
        className="btn btn-wide"
        value={`go to ${storeName}`}
      />
    </div>
  </form>
);

ExternalPurchaseForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  storeName: PropTypes.string.isRequired,
  shippingAddress: PropTypes.shape({}),
  stillNeeds: PropTypes.string,
};

const mapStateToProps = state => ({
  initialValues: {
    giftGiverEmail: state.external.giftGiverEmail,
  },
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'ExternalPurchaseForm',
    validate: values => {
      const errors = {};
      if (values.giftGiverEmail !== values.confirmGiftGiverEmail) {
        errors.confirmGiftGiverEmail = 'Email does not match.';
      }
      return errors;
    },
  })(ExternalPurchaseForm)
);



// WEBPACK FOOTER //
// ./src/components/registryitem/ExternalPurchaseForm.jsx